import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["name", "logo", "logoPlaceholder"]

  updateName(event) {
    const value = event.target.value.trim()
    this.nameTargets.forEach((el) => {
      el.textContent = value
        ? `${value} is requesting the following documents`
        : "Your company is requesting the following documents"
    })
  }

  updateLogo(event) {
    const src = event.detail.src
    if (!src) return

    this.logoTargets.forEach((el) => {
      el.src = src
      el.classList.remove("hidden")
    })

    this.logoPlaceholderTargets.forEach((el) => {
      el.classList.add("hidden")
    })
  }
}
